"use client";
// components/ClusterPanel.jsx
import ShareModal from "./ShareModal";
import { useState, useEffect, useRef } from "react";
import WishlistSummaryCard from "./WishlistSummaryCard";
import BucketList from "./BucketList";

// ── Main panel ────────────────────────────────────────────────────────────────
export default function ClusterPanel({ schoolIDs, filters, onClose, onViewDetail }) {
  const [current, setCurrent] = useState(0);
  const [dir,     setDir]     = useState(null);
  const [copied, setCopied] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const shareURL = typeof window !== "undefined"
    ? `${window.location.origin}/teacher/${schoolIDs[current]}`
    : "";
  if (!schoolIDs?.length) return null;
  const total = schoolIDs.length;

  const go = (direction) => {
    setDir(direction);
    setTimeout(() => {
      setCurrent(prev => direction === "right"
        ? Math.min(prev + 1, total - 1)
        : Math.max(prev - 1, 0));
      setDir(null);
    }, 180);
  };
  const handleOpenShare = () => {
    window.history.pushState({}, "", `/teacher/${schoolIDs[current]}`);
    setShareOpen(true);
  };
  const handleCloseShare = () => {
    window.history.pushState({}, "", "/");
    setShareOpen(false);
  };

  return (
    <div style={{
      position: "absolute", top: 0, right: 0,
      width: 340, height: "100%",
      background: "#fffbf5", borderLeft: "3px solid #fde68a",
      boxShadow: "-8px 0 32px rgba(0,0,0,0.12)",
      display: "flex", flexDirection: "column",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      zIndex: 20, animation: "slideIn .25s ease",
    }}>
      <style>{`
        @keyframes slideIn  { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        @keyframes flipLeft  { 0%{opacity:1;transform:translateX(0)} 50%{opacity:0;transform:translateX(-24px)} 100%{opacity:1;transform:translateX(0)} }
        @keyframes flipRight { 0%{opacity:1;transform:translateX(0)} 50%{opacity:0;transform:translateX(24px)}  100%{opacity:1;transform:translateX(0)} }
      `}</style>

      {/* Header */}
      <div style={{ background: "#fffbf5", borderBottom: "3px solid #fde68a", padding: "12px 14px 10px", flexShrink: 0, position: "relative" }}>
        {[...Array(3)].map((_, i) => (
          <div key={i} style={{ position: "absolute", left: 0, right: 0, top: 16 + i * 13, height: 1, background: "rgba(147,197,253,0.2)", pointerEvents: "none" }} />
        ))}
        <div style={{ position: "absolute", left: 40, top: 0, bottom: 0, width: 2, background: "rgba(252,165,165,0.35)", pointerEvents: "none" }} />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: 8 }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 900, color: "#dc2626" }}>
              {total > 1 ? `🏫 ${total} Teachers at this School` : "🎁 Wishlist"}
            </div>
            {total > 1 && <div style={{ fontSize: 10, color: "#92400e", marginTop: 1 }}>Use arrows to browse</div>}
          </div>
          {/* <button onClick={handleOpenShare} style={{
            padding: "5px 12px", borderRadius: 20,
            border: "2px solid #fde68a", background: "#fff9e6",
            color: "#92400e", fontWeight: 800, fontSize: 12, cursor: "pointer",
          }}>
            🔗 Share
          </button>
          {shareOpen && (
            <ShareModal
              schoolID={schoolIDs[current]}
              filters={filters}
              onClose={handleCloseShare}
            />
          )} */}
          <button onClick={onClose} style={{
            width: 28, height: 28, borderRadius: "50%",
            background: "#fef2f2", border: "2px solid #fca5a5",
            color: "#dc2626", fontSize: 16, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700,
          }}>×</button>
        </div>
        
      </div>

      {/* Dots */}
      {total > 1 && (
        <div style={{ display: "flex", justifyContent: "center", gap: 6, padding: "8px 0 4px", flexShrink: 0 }}>
          {schoolIDs.map((_, i) => (
            <button key={i}
              onClick={() => { setDir(i > current ? "right" : "left"); setTimeout(() => { setCurrent(i); setDir(null); }, 180); }}
              style={{ width: i === current ? 20 : 8, height: 8, borderRadius: 999, border: "none", cursor: "pointer", padding: 0, transition: "all .2s", background: i === current ? "#f97316" : "#fde68a" }}
            />
          ))}
        </div>
      )}

      {total > 1 && (
        <div style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: "#92400e", paddingBottom: 4, flexShrink: 0 }}>
          Teacher {current + 1} of {total}
        </div>
      )}

      {/* Scrollable content */}
      <div style={{ flex: 1, overflowY: "auto" }}>
        <div style={{ animation: dir === "right" ? "flipRight .36s ease" : dir === "left" ? "flipLeft .36s ease" : "none" }}>
          <div style={{ padding: "0 12px 12px" }}>
            <div style={{ background: "#fff", borderRadius: 16, border: "2px solid #fde68a", boxShadow: "3px 3px 0 #fde68a", overflow: "hidden" }}>
              <WishlistSummaryCard
                schoolID={schoolIDs[current]}
                itemMinPrice={filters?.itemMinPrice}
                itemMaxPrice={filters?.itemMaxPrice}
                categories={filters?.categories}
                onViewDetail={onViewDetail}
              />
            </div>
          </div>
          <BucketList
            schoolID={schoolIDs[current]}
            itemMinPrice={filters?.itemMinPrice}
            itemMaxPrice={filters?.itemMaxPrice}
            categories={filters?.categories}
          />
        </div>
      </div>

      {/* Prev / Next */}
      {total > 1 && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px 14px", borderTop: "2px dashed #fde68a", flexShrink: 0, gap: 8 }}>
          <button onClick={() => go("left")} disabled={current === 0} style={{
            flex: 1, padding: "10px 0", borderRadius: 12, border: "2px solid #fde68a",
            fontWeight: 800, fontSize: 14, cursor: current === 0 ? "not-allowed" : "pointer",
            background: current === 0 ? "#f8fafc" : "#fff9e6",
            color:      current === 0 ? "#cbd5e1" : "#92400e", transition: "all .15s",
          }}>← Prev</button>
          <div style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600, textAlign: "center", minWidth: 40 }}>
            {current + 1}/{total}
          </div>
          <button onClick={() => go("right")} disabled={current === total - 1} style={{
            flex: 1, padding: "10px 0", borderRadius: 12, border: "2px solid #fde68a",
            fontWeight: 800, fontSize: 14, cursor: current === total - 1 ? "not-allowed" : "pointer",
            background: current === total - 1 ? "#f8fafc" : "#fff9e6",
            color:      current === total - 1 ? "#cbd5e1" : "#92400e", transition: "all .15s",
          }}>Next →</button>
        </div>
      )}
      {shareOpen && (
        <ShareModal
          schoolID={schoolIDs[current]}
          filters={filters}
          onClose={() => setShareOpen(false)}
        />
      )}
    </div>
  );
}